<template>
  <div :class="{'item': true, 'item-right': isEven, 'item-left': !isEven}">
    <div class="date"><span>{{ date }}</span></div>
    <div class="logo" v-if="logo">
      <img v-if="typeof logo === 'string'" :src="logo">
      <template v-else>
        <img v-for="(logoItem, logoIndex) in logo" :key="logoIndex" :src="logoItem">
      </template>
    </div>
    <div class="description">
      {{ description }}
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line no-undef
defineProps({
  date: {
    type: String,
    required: true
  },
  logo: {
    type: [String, Array, null],
    default: null
  },
  description: {
    type: String,
    required: true
  },
  isEven: {
    type: Boolean,
    required: true
  }
});
</script>

<style lang="scss" scoped>
.item {
  width: 50%;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: $color-pink-dark-2;
    top: 25px;
    z-index: 1;
  }
}

.item-left {
  text-align: right;
  margin-left: 0;
  padding-right: 40px;

  &::after {
    right: -3px;
  }
}

.item-right {
  text-align: left;
  margin-left: 50%;
  padding-left: 40px;

  &::after {
    left: -4px;
  }
}

.logo {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;

  img {
    max-height: 120px;
    width: auto;
    margin: 5px;
  }
}

.item-right .logo {
  justify-content: flex-start;
}

.date {
  margin-bottom: 10px;
  span {
    background: $color-pink-dark-2;
    color: #fff;
    padding: 7px;
    font-size: 12px;
    border-radius: 20px;
  }
}

.description {
  margin-top: 10px;
}

/* Mobile styles */
@media (max-width: 768px) {
  .item, .item-left, .item-right {
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 15px;

    &::after {
      display: none;
    }
  }

  .logo, .item-right .logo {
    justify-content: center;
  }
}
</style>
